<template>
  <!-- 直播详情 -->
  <div class="index-container">
    <div class="course-container">
      <div class="nav-box">
        首页 > 大健康人才培训 > 课程列表
        <span>> {{ info.title }}</span>
      </div>
      <div class="play-info">
        <div class="info-img" :style="{ backgroundImage: 'url( ' + imgUrl + info.avatar + ')' }"></div>
        <div class="right-box">
          <div class="name-box">
            {{ info.teacher_name }}
            <span
              class="i-status"
              :class="
                info.play_status === 1
                  ? 'no-status'
                  : info.play_status === 3
                  ? 'over-status'
                  : ''
              "
            >
              {{
              info.play_status === 1
              ? "未开始"
              : info.play_status === 2
              ? "直播中"
              : "已结束"
              }}
            </span>
            <span class="i-time">开播时间：{{ info.start_time }}</span>
          </div>
          <div class="i-title">{{ info.title }}</div>
        </div>
      </div>
      <div class="video-box" v-loading="loading">
        <videoPlayer
          :cover="imgUrl + info.cover"
          :liveUuid="playUuid.uuid"
          :danmu="barrageList"
          v-if="videoSrc"
          :url="videoSrc"
          :play_status="info.play_status"
        ></videoPlayer>
        <div class="start-button" v-if="payState === '未支付'">审核支付中</div>
        <div class="pay-box" v-if="info.is_order == 0 && info.play_status != 3">
          <div class="p-title">内容付费提醒</div>
          <div class="p-tip">该直播为付费内容，请支付后观看</div>
          <div class="money-text">
            需支付：
            <span>¥{{ info.price }}</span>
          </div>
          <div class="pay-btn" @click="goPay">去支付</div>
        </div>
        <div class="room-box">
          <div class="r-title">请输入房间密码</div>
          <div class="line"></div>
          <div class="num-input-box">
            <el-input v-model="numOne" maxlength="1" @change="oneFocus()"></el-input>
            <el-input v-model="numTwo" maxlength="1" @change="twoFocus()" ref="twoInput"></el-input>
            <el-input v-model="numThree" maxlength="1" @change="threeFocus()" ref="threeInput"></el-input>
            <el-input v-model="numFour" maxlength="1" @change="fourFocus()" ref="fourInput"></el-input>
            <el-input v-model="numFive" maxlength="1" @change="fiveFocus()" ref="fiveInput"></el-input>
            <el-input v-model="numSix" maxlength="1" ref="sixInput"></el-input>
          </div>
          <div class="confirm-btn">确定</div>
        </div>
      </div>
      <div class="barrage-box">
        <div
          class="b-text"
          :class="isSend ? '' : 'no-text'"
          :showDanmu="showDanmu"
          @click="closeDanmu"
        >弹幕</div>
        <div class="input-box">
          <el-input placeholder="请输入内容" v-model="barrageValue">
            <template slot="append">
              |
              <span @click="save()">发送</span>
            </template>
          </el-input>
        </div>
      </div>
      <div class="detail-content">
        <div class="left-box">
          <div class="detail-module">
            <div class="d-title">直播介绍</div>
            <div class="play-words" v-html="info.detail"></div>
            <!-- <div class="img-box">
              <div
                class="img-list"
                v-for="(item,index) in imgList"
                :key=" 'img' + index"
                :style="{ backgroundImage: 'url( ' + item + ')' }"
              ></div>
            </div>-->
          </div>
        </div>
        <div class="right-box" v-if="info.recommend.length > 0">
          <div class="detail-module">
            <div class="d-title">推荐直播</div>
            <div class="course-list-box">
              <div
                class="course-list"
                v-for="(item, index) in info.recommend"
                :key="index"
                @click="goPlayDetail(item)"
              >
                <div
                  class="list-img"
                  :style="{
                    backgroundImage: 'url( ' + imgUrl + item.cover + ')'
                  }"
                >
                  <div
                    class="list-status"
                    :class="
                      item.play_status === 1
                        ? 'no-status'
                        : item.play_status === 3
                        ? 'over-status'
                        : ''
                    "
                  >
                    <i
                      class="iconfont-icon"
                      :class="
                        item.play_status === 1
                          ? 'icon-weikaishi'
                          : item.play_status === 3
                          ? 'icon-jingshi1'
                          : 'icon-ziyuanldpi'
                      "
                    ></i>
                    {{
                    item.play_status === 1
                    ? "未开始"
                    : item.play_status === 2
                    ? "直播中"
                    : "已结束"
                    }}
                  </div>
                </div>
                <div class="right-content">
                  <div class="list-type over-type" v-if="item.play_status === 3">已结束</div>
                  <div class="list-type ing-type" v-else-if="item.play_status === 2">正在直播</div>
                  <div class="list-type" v-else>开播时间：{{ item.start_time }}</div>
                  <div class="list-title">{{ item.title }}</div>
                  <div class="list-price">
                    <div>
                      <span>¥</span>
                      {{ item.price }}
                    </div>
                    <span class="list-sale">已有{{ item.sales }}人已购买</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 选择付款方式 -->
    <el-dialog
      class="form-box"
      :visible.sync="wayVisible"
      width="570PX"
      :close-on-click-modal="false"
    >
      <div class="form-title">选择付款方式</div>
      <div class="way-box">
        <div
          class="way-list"
          @click="waySelect(item, index)"
          v-for="(item, index) in wayList"
          :key="'way' + index"
          :class="index === wayIndex ? 'way-active' : ''"
        >
          <div class="active-img" :style="{ backgroundImage: 'url( ' + activeImg + ')' }"></div>
          <i class="iconfont-icon" :class="item.icon"></i>
          {{ item.name }}
        </div>
      </div>
      <div class="submit-button" @click="wayNext">下一步</div>
    </el-dialog>
    <!-- 付款信息 -->
    <el-dialog
      class="form-box"
      :visible.sync="infoVisible"
      width="570PX"
      :close-on-click-modal="false"
    >
      <div class="form-title">付款信息</div>
      <div class="text-box first-box">
        <div class="t-title">课程名称：{{ wayInfo.order_name }}</div>
        <div class="t-text">
          应付金额：
          <span>¥{{ wayInfo.order_amount }}</span>
        </div>
      </div>
      <div
        class="code-img"
        :style="{
          backgroundImage: 'url( ' + imgUrl + wayInfo['pay_url'] + ')'
        }"
      ></div>
      <div class="text-box">
        <div class="t-text">流水号：{{ wayInfo.order_sn }}</div>
        <div class="t-text">付款日期：{{ wayInfo.create_time }}</div>
      </div>
      <div class="submit-button have-btn" @click="havePay">已支付</div>
    </el-dialog>
    <!-- 付款信息2 -->
    <el-dialog
      class="form-box"
      :visible.sync="infoTwoVisible"
      width="40%"
      :close-on-click-modal="false"
    >
      <div class="form-title">付款信息</div>
      <div class="text-box">
        <div class="t-title">课程名称：{{ wayInfo.live_title }}</div>
        <div class="t-text">
          应付金额：
          <span>¥{{ wayInfo.order_money }}</span>
        </div>
      </div>
      <div class="text-box">
        <div class="t-text">流水号：{{ wayInfo.order_sn }}</div>
        <div class="t-text">付款日期：{{ wayInfo.create_time }}</div>
      </div>
      <div class="way-title">收款信息</div>
      <div class="money-box">
        <div class="money-info">
          公司名称：
          <span>{{ wayInfo.company_name }}</span>
        </div>
        <div class="money-info">
          开户银行：
          <span>{{ wayInfo.company_bank }}</span>
        </div>
        <div class="money-info">
          收款账号：
          <span>{{ wayInfo.company_no }}</span>
        </div>
      </div>
      <template v-if="wayInfo.pay_state === 0">
        <div class="way-title">付款凭证</div>
        <div class="tip-text">*请打款到指定收款账号并上传支付凭证截图</div>
        <el-upload
          :action="uploadUrl"
          list-type="picture-card"
          :on-remove="handleRemove"
          :on-success="successUpload"
          :file-list="fileList"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </template>
      <div class="submit-button have-btn" @click="havePay">已支付</div>
    </el-dialog>
  </div>
</template>
<script>
import videoPlayer from '../components/videoPlayer.vue';
import api from '../api/api';
import { upload_url } from '../api/index';
import { imgUrl } from '../api/index';
import selectImg from '@/assets/img/gouxuan_bg.png';

export default {
  name: 'playDetail',
  components: {
    videoPlayer
  },
  data() {
    return {
      activeImg: selectImg,
      imgUrl: imgUrl,
      info: {
        recommend: []
      },
      videoUrl: '',
      barrageValue: '',
      imgList: ['', '', '', '', '', ''],
      courseList: [],
      numOne: '',
      numTwo: '',
      numThree: '',
      numFour: '',
      numFive: '',
      numSix: '',
      bannerList: [],
      playUuid: {},
      wayList: [
        // 付款方式
        {
          icon: 'icon-weixinfukuan',
          name: '微信支付',
          id: 2
        },
        {
          icon: 'icon-zhifubao',
          name: '支付宝支付',
          id: 1
        },
        {
          icon: 'icon-duigongzhuanzhang',
          name: '对公转账',
          id: 3
        },
        {
          icon: 'icon-xianjinzhifu',
          name: '现金支付',
          id: 4
        }
      ],
      pay_type: '',
      wayIndex: '',
      wayVisible: false,
      wayInfo: {},
      infoVisible: false,
      infoTwoVisible: false,
      uploadUrl: upload_url, // 上传地址
      fileList: [],
      pay_img: '',
      videoSrc: '',
      barrageList: [],
      isSend: true,
      showDanmu: true,
      danmuTimer: '',
      payTimer: '',
      payState: '未支付',
      loading: true
    };
  },
  beforeDestroy() {
    clearInterval(this.danmuTimer);
    clearInterval(this.payTimer);
    this.payTimer = null;
    this.danmuTimer = null;
  },
  watch: {
    playState() {
      console.log(this.wayInfo.order_sn);
      return this.wayInfo.order_sn;
    }
  },
  mounted() {
    console.log(this.playState);
    this.payTimer = setInterval(() => {
      setTimeout(this.checkPay(), 0);
    }, 5000);
    scrollTo(0, 0);
    const that = this;
    this.danmuTimer = setInterval(() => {
      setTimeout(that.getBarrageList(), 0);
    }, 5000);
  },
  created() {
    const value = this.$route.query;
    console.log(value);
    if (value.uuid) {
      this.playUuid = value;
      this.getLiveDetail(value);
      this.lookLiveing();
      this.getBarrageList();
    }
  },
  methods: {
    //   检测是否知否成功
    checkPay() {
      console.log(this.wayInfo.order_sn);
      if (this.wayInfo.order_sn) {
        api.checkPay({ order_sn: this.wayInfo.order_sn }).then(res => {
          console.log(res);
          if (res.result) {
            clearInterval(this.payTimer);
            this.payTimer = null;
            this.payState = '已支付';
            this.loading = false;
            this.$message.success('已支付成功！');
          } else {
            this.payState = '未支付';
          }
        });
      }
    },
    closeDanmu() {
      this.isSend = !this.isSend;
      if (!this.isSend) {
        this.showDanmu = false;
        // this.bannerList = [];
      } else {
        this.showDanmu = true;
        this.getBarrageList();
      }
    },
    // 发送弹幕
    save() {
      const params = {
        detail: this.barrageValue,
        liveUuid: this.playUuid.uuid
      };
      console.log(params);
      api.sendBarrage(params).then(res => {
        if (res && res.result) {
          this.getBarrageList();
          this.barrageValue = '';
        } else {
          this.$message.warning('发送失败！');
        }
      });
    },
    // 获取直播地址
    lookLiveing() {
      api.playLiveing({ uuid: this.playUuid.uuid }).then(res => {
        console.log(res);
        this.videoSrc = res.result.pull_flow_m3u8;
      });
    },
    // 获取弹幕列表
    getBarrageList() {
      const param = {
        live_uuid: this.playUuid.uuid
      };
      api.getBarrageList(param).then(res => {
        if (res && res.result) {
          this.barrageList = res.result.data;
        }
      });
    },
    goPay() {
      const isLogin = localStorage.getItem('X-Access-Token');
      console.log(isLogin);
      if (isLogin) {
        this.wayVisible = true;
      } else {
        location.reload();
      }
    },
    // 付款方式后下一步
    wayNext() {
      if (!this.pay_type) {
        this.$message.warning('请选择付款方式！');
      } else {
        const params = {
          pay_type: this.pay_type,
          live_uuid: this.playUuid.uuid
        };
        const that = this;
        api.createPlayOrder(params).then(res => {
          console.log(res);
          if (res.result) {
            if (this.pay_type === 3) {
              this.wayInfo = res.result;
              this.wayVisible = false;
              this.infoTwoVisible = true;
              this.loading = true;
              return;
            }
            if (res.result.pay_state == 1) {
              that.wayVisible = false;
            } else {
              that.commodityPay(res.result.order_sn);
            }
          } else {
            location.reload();
          }
        });
      }
    },
    commodityPay(order_sn) {
      api.commodityPay({ order_sn: order_sn }).then(res => {
        if (res.result) {
          this.wayInfo = res.result;
          this.wayVisible = false;
          if (this.pay_type === 3) {
            this.infoTwoVisible = true;
            return;
          }
          this.infoVisible = true;
        } else {
          this.$message.warning('订单信息有误！');
        }
        this.loading = true;
      });
    },
    // 支付方式选择
    waySelect(item, index) {
      this.pay_type = item.id;
      this.wayIndex = index;
    },
    // 已支付
    havePay() {
      if (this.infoVisible === true) {
        this.info.is_order = 1;
        this.infoVisible = false;
        return;
      }
      if (this.wayInfo.pay_state === 1) {
        this.info.is_order = 1;
        this.infoTwoVisible = false;
        return;
      }
      if (!this.pay_img) {
        this.$message.warning('请上传支付凭证！');
        return;
      }
      api
        .updatePlayOrder({
          order_sn: this.wayInfo.order_sn,
          pay_img: this.pay_img
        })
        .then(res => {
          if (res.result) {
            this.$message.success('支付成功！');
            this.infoTwoVisible = false;
            this.info.is_order = 1;
          }
        });
    },
    // 获取直播详情
    getLiveDetail(value) {
      return api.getLiveDetail(value).then(res => {
        this.info = res.result;
        if (this.info.is_order === 1) {
          this.payState = '已支付';
          clearInterval(this.payTimer);
          this.payTimer = null;
          console.log(this.payTimer);
        }
        this.info.detail = this.changeShowImg(this.info.detail);
        this.loading = false;
      });
    },
    changeShowImg(obj) {
      const baseImg = 'https://train-service-api.procaregroup.com/';
      const objstr = JSON.stringify(obj);
      const midStr = 'train_service/app_upload';
      const str = objstr.replace(new RegExp(baseImg, 'g'), '');
      const str1 = str.replace(
        new RegExp(midStr, 'g'),
        'https://train-service-api.procaregroup.com/train_service/app_upload'
      );
      return JSON.parse(str1);
    },
    // 推荐直播
    goPlayDetail(item) {
      this.$router.push({
        path: '/playDetail',
        query: { uuid: item.uuid }
      });
    },
    // 凭证移除
    handleRemove(file) {
      this.pay_img = '';
    },
    // 上传成功
    successUpload(res, file, fileList) {
      if (res.result) {
        this.pay_img = res.result;
        this.$message.success('上传成功！');
      } else {
        this.$message.warning('上传失败！');
      }
    },
    oneFocus() {
      this.$refs.twoInput.focus();
    },
    twoFocus() {
      this.$refs.threeInput.focus();
    },
    threeFocus() {
      this.$refs.fourInput.focus();
    },
    fourFocus() {
      this.$refs.fiveInput.focus();
    },
    fiveFocus() {
      this.$refs.sixInput.focus();
    }
  }
};
</script>

<style lang="scss" scoped>
.index-container {
  margin-top: 122PX;
  background-color: #f8f7f6;
}
.course-container {
  width: 72%;
  padding: 50PX 0;
  margin: 0 auto;
}
.nav-box {
  padding-bottom: 46PX;
  font-size: 16PX;
  color: #333333;
  span {
    color: #7d7d7d;
  }
}
.play-info {
  display: flex;
  padding: 24PX 36PX 18PX;
  background-color: #ffffff;
  border-radius: 16PX 16PX 0PX 0PX;
  .info-img {
    width: 102PX;
    height: 102PX;
    margin-right: 20PX;
    background-color: #f8f7f6;
    border-radius: 50%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .name-box {
    padding-top: 10PX;
    font-size: 18PX;
  }
  .i-status {
    width: 60PX;
    height: 32PX;
    padding: 6PX;
    margin-left: 10PX;
    font-size: 16PX;
    color: #77e323;
    text-align: center;
    line-height: 32PX;
    background-color: rgba($color: #20d220, $alpha: 0.1);
    border-radius: 4PX;
  }
  .no-status {
    color: #989898;
    background-color: rgba($color: #b7b7b7, $alpha: 0.3);
  }
  .over-status {
    color: #f91818;
    background-color: rgba($color: #f91818, $alpha: 0.3);
  }
  .i-time {
    padding-left: 14PX;
    font-size: 14PX;
  }
  .i-title {
    padding-top: 12PX;
    font-size: 26PX;
  }
}
.video-box {
  position: relative;
  width: 100%;
  height: 714PX;
  background-color: rgba($color: #b7b7b7, $alpha: 0.3);
}
.banner-img {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  background-repeat: no-repeat;
  background-size: cover;
  .iconfont {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    font-size: 80PX;
    color: #ffffff;
    cursor: pointer;
  }
}
.detail-content {
  display: flex;
  justify-content: space-between;
}
.left-box {
  width: 66%;
  overflow: auto;
  background-color: #ffffff;
}
.right-box {
  //   width: 32%;
  flex: 1;
  //   margin-left: 20PX;
  background-color: #ffffff;
}
.detail-module {
  padding: 25PX 25PX 0;
  margin-bottom: 20PX;
  background-color: #ffffff;
  .d-title {
    position: relative;
    padding-bottom: 16PX;
    font-size: 20PX;
    color: #f1a373;
    border-bottom: 1PX solid #ececec;
    &::after {
      position: absolute;
      left: 12PX;
      bottom: 0;
      width: 55PX;
      height: 3PX;
      background-color: #f1a373;
      content: '';
    }
  }
  .play-words {
    padding: 24PX 16PX;
    font-size: 16PX;
    font-weight: 400;
    color: #333333;
    line-height: 27PX;
    word-wrap: break-word;
    white-space: normal;
    word-break: break-all;
    overflow-y: auto;
  }
}
.img-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 6PX 0 0;
  .img-list {
    width: calc((100% - 68PX) / 3);
    height: 184PX;
    margin-bottom: 30PX;
    background-color: #ececec;
  }
}
.course-list-box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 48PX 0 0;
  .course-list {
    width: 100%;
    padding: 20PX 14PX 24PX 18PX;
    margin-bottom: 15PX;
    background: #ffffff;
    cursor: pointer;
    &:hover {
      box-shadow: 0PX 3PX 15PX 1PX rgba(200, 200, 200, 0.35);
      .list-title {
        color: #f6aa2b;
      }
    }
  }
  .list-img {
    width: 100%;
    height: 208PX;
    background-color: #fdefe7;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .list-status {
    width: 80PX;
    height: 30PX;
    font-size: 12PX;
    color: #77e323;
    text-align: center;
    line-height: 30PX;
    background: rgba($color: #151515, $alpha: 0.4);
    border-radius: 0PX 0PX 19PX 0PX;
  }
  .no-status {
    color: #ffffff;
  }
  .over-status {
    color: #f91818;
  }
  .icon-weikaishi {
    position: relative;
    top: 2PX;
    color: #ffffff;
  }
  .icon-jingshi1 {
    color: #f91818;
  }
  .icon-ziyuanldpi {
    color: #77e323;
  }
  .right-content {
    flex: 1;
    padding: 10PX 0;
  }
  .list-type {
    display: inline-flex;
    padding: 2PX 8PX;
    font-size: 12PX;
    color: #eca021;
    background-color: rgba($color: #ffdca1, $alpha: 0.3);
    border-radius: 10PX;
  }
  .over-type {
    color: #b1b0ae;
    background-color: rgba($color: #b7b7b7, $alpha: 0.3);
  }
  .ing-type {
    color: #0fe21f;
    background-color: rgba($color: #20d220, $alpha: 0.1);
  }
  .list-title {
    padding: 10PX 0;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .list-detail {
    margin-bottom: 20PX;
    font-size: 12PX;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .list-date {
    display: inline-flex;
    padding: 0 12PX;
    margin-bottom: 16PX;
    font-size: 10PX;
    color: #ff7b1f;
    line-height: 24PX;
    background-color: #fdefe7;
    border-radius: 12PX;
  }
  .list-price {
    display: flex;
    justify-content: space-between;
    font-size: 18PX;
    color: #ec5d16;
    font-weight: bold;
    span {
      font-size: 14PX;
    }
    .list-sale {
      padding-left: 16PX;
      font-size: 12PX;
      color: #929292;
      font-weight: normal;
      line-height: 24PX;
    }
  }
}
.pay-box {
  position: absolute;
  z-index: 1000;
  top: 38%;
  left: 50%;
  transform: translate(-50%);
  width: 512PX;
  height: 255PX;
  padding: 32PX 0 22PX;
  text-align: center;
  background: linear-gradient(117deg, #313131 0%, #1a1a1b 100%);
  border-radius: 16PX;
  .p-title {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-size: 16PX;
    color: #f6dea5;
    &::before {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: -145PX;
      width: 126PX;
      height: 1PX;
      border: 1PX solid;
      border-image: linear-gradient(
          133deg,
          rgba(51, 51, 51, 1),
          rgba(217, 189, 126, 1)
        )
        1 1;
      content: '';
    }
    &::after {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: -165PX;
      width: 145PX;
      height: 1PX;
      border: 1PX solid;
      border-image: linear-gradient(
          133deg,
          rgba(217, 189, 126, 1),
          rgba(26, 26, 27, 1)
        )
        1 1;
      content: '';
    }
  }
  .p-tip {
    padding: 50PX 0 15PX;
    font-size: 16PX;
    color: #f6dea5;
  }
  .money-text {
    padding-bottom: 12PX;
    color: #f6dea5;
    span {
      font-size: 18PX;
      color: #d31212;
    }
  }
  .pay-btn {
    width: 150PX;
    height: 44PX;
    margin: 0 auto;
    font-size: 18PX;
    color: #9a5a0a;
    line-height: 44PX;
    text-align: center;
    background: linear-gradient(302deg, #cd9663 0%, #f6dea5 100%);
    border-radius: 1PX;
    cursor: pointer;
  }
}
.room-box {
  display: none;
  position: absolute;
  top: 38%;
  left: 50%;
  transform: translate(-50%);
  width: 489PX;
  height: 230PX;
  padding: 30PX 52PX;
  background: linear-gradient(117deg, #313131 0%, #1a1a1b 100%);
  border-radius: 16PX;
  opacity: 0.86;
  .r-title {
    padding-bottom: 10PX;
    font-size: 16PX;
    color: #ffffff;
    text-align: center;
  }
  .line {
    width: 115PX;
    height: 1PX;
    margin: 0 auto 20PX;
    border: 1PX solid;
    border-image: linear-gradient(
        90deg,
        rgba(30, 31, 37, 0.27),
        rgba(255, 255, 255, 1),
        rgba(80, 80, 80, 0.16)
      )
      1 1;
  }
  .num-input-box {
    display: flex;
    margin: 0 auto 26PX;
  }
  .confirm-btn {
    width: 150PX;
    height: 44PX;
    margin: 0 auto;
    font-size: 18PX;
    color: #ffffff;
    line-height: 44PX;
    text-align: center;
    background-color: #f1a475;
    border-radius: 6PX;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  /deep/ {
    .el-input {
      width: 48PX;
      height: 48PX;
      margin-right: 20PX;
      background-color: #ffffff;
      border-radius: 2PX;
      &:last-child {
        margin-right: 0;
      }
    }
    .el-input__inner {
      height: 48PX;
      padding: 0;
      text-align: center;
      line-height: 48PX;
    }
  }
}
.form-box {
  .form-title {
    padding-bottom: 38PX;
    font-size: 22PX;
    text-align: center;
  }
  .form-question {
    padding-bottom: 16PX;
    font-size: 16PX;
  }
  .rideo-box {
    margin-bottom: 30PX;
  }
  .submit-button {
    width: 218PX;
    height: 52PX;
    margin: 52PX auto 0;
    font-size: 18PX;
    color: #ffffff;
    text-align: center;
    line-height: 52PX;
    background-color: #f1a373;
    border-radius: 45PX;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .rank-box {
    text-align: center;
  }
  .way-box {
    display: flex;
    flex-wrap: wrap;
    width: 76%;
    margin: 0 auto;
  }
  .way-list {
    position: relative;
    display: flex;
    align-items: center;
    width: 162PX;
    height: 50PX;
    margin-bottom: 14PX;
    font-size: 16PX;
    line-height: 50PX;
    text-align: center;
    border-radius: 5PX;
    border: 1PX solid #cbcbcb;
    cursor: pointer;
    &:nth-child(2n) {
      margin-left: 45PX;
    }
    &:hover {
      border-color: #f1a475;
      .active-img {
        display: block;
      }
    }
    .iconfont-icon {
      padding: 0 14PX 0 24PX;
      font-size: 28PX;
      line-height: 50PX;
    }
  }
  .way-active {
    border-color: #f1a475;
    .active-img {
      display: block;
    }
  }
  .active-img {
    position: absolute;
    display: none;
    top: 0;
    right: -1PX;
    width: 28PX;
    height: 28PX;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .icon-weixinfukuan {
    color: #6bcc03;
  }
  .icon-zhifubao {
    color: #189fe4;
  }
  .icon-duigongzhuanzhang {
    color: #faad14;
  }
  .icon-xianjinzhifu {
    color: #f8b551;
  }
  .text-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .t-text:last-child {
      padding-left: 20PX;
    }
  }
  .first-box {
    margin-bottom: 20PX;
  }
  .t-title {
    font-size: 16PX;
  }
  .t-text {
    font-size: 14PX;
    color: #666666;
    line-height: 40PX;
    span {
      font-size: 30PX;
      color: #c00c0c;
    }
  }
  .code-img {
    width: 358PX;
    height: 322PX;
    margin: 0 auto 32PX;
    background-color: #d8d8d8;
    border: 1PX solid #979797;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .have-btn {
    margin-top: 20PX;
  }
  .way-title {
    padding: 40PX 0 12PX;
    margin-bottom: 22PX;
    font-size: 16PX;
    color: #f1a475;
    border-bottom: 1PX solid #e7e7e7;
  }
  .money-box {
    padding: 14PX 8PX;
    background-color: #f6f6f6;
  }
  .money-info {
    padding-bottom: 14PX;
    color: #666666;
    span {
      color: #000000;
    }
  }
  .tip-text {
    padding-bottom: 22PX;
    color: #f90000;
  }
}
.barrage-box {
  display: flex;
  align-items: center;
  padding: 28PX 44PX;
  margin-bottom: 26PX;
  background-color: #282828;
  .b-text {
    position: relative;
    width: 88PX;
    height: 40PX;
    padding-left: 32PX;
    margin-right: 40PX;
    font-size: 18PX;
    color: #f1a475;
    line-height: 40PX;
    border-radius: 23PX;
    border: 1PX solid #f1a475;
    cursor: pointer;
    &::before {
      position: absolute;
      top: 50%;
      left: 14PX;
      transform: translateY(-50%);
      width: 9PX;
      height: 9PX;
      background: #f1a475;
      border-radius: 50%;
      content: '';
    }
  }
  .no-text {
    color: #999999;
    border: 1PX solid #999999;
    &::before {
      background: #999999;
    }
  }
  .input-box {
    display: flex;
    width: 48%;
    padding: 1px 0;
    background: #171616;
    border-radius: 28PX;
    span {
      padding-left: 14PX;
      &:hover {
        color: #ffffff;
      }
    }
    .no-send {
      cursor: not-allowed;
    }
  }
}
/deep/ {
  .el-input__inner {
    color: #ffffff;
    border-color: transparent;
    background-color: transparent;
  }
  .el-input-group__append {
    padding-right: 30PX;
    border-color: transparent;
    background-color: transparent;
    cursor: pointer;
  }
}
.start-button {
  position: absolute;
  z-index: 999;
  top: 44%;
  left: 50%;
  transform: translate(-50%);
  width: 288PX;
  height: 80PX;
  margin: 0 auto;
  font-size: 30PX;
  color: #ffffff;
  text-align: center;
  line-height: 80PX;
  background-color: #f1a373;
  border-radius: 6PX;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/playDetail.vue